const BASE_EVENT = 'Lists';

export const LISTS_EVENTS = {
  BASE: BASE_EVENT,
  CONTACT_LIST: BASE_EVENT + ' - Contact List',
  ACCOUNT_LIST: BASE_EVENT + ' - Account List',
  LIST_SELECTED: BASE_EVENT + ' - List Selected',
  ACTIONS: {
    LIST_EXPORT: BASE_EVENT + ' - Actions - List Export',
  },
  HPM: {
    AI_MESSAGE: BASE_EVENT + ' - List Selected - AI Message',
    GENERATE_HPM: BASE_EVENT + ' - List Selected - Generate',
    AUTO_GENERATE: BASE_EVENT + ' - List Selected - AI Message - Auto Generate Messages',
    AUTO_GENERATE_CONFIRM:
      BASE_EVENT + ' - List Selected - AI Message - Auto Generate Messages - Proceed',
    CUSTOM_PROMPT: BASE_EVENT + '- List Selected - AI Message - Custom Prompt',
    CUSTOM_PROMPT_CONFIRM: BASE_EVENT + '- List Selected - AI Message - Custom Prompt - Proceed',
  },
  BULK_SELECTION: {
    SELECT_THIS_PAGE: 'Select this page',
    SELECT_ALL: 'Select All',
    SELECT_CUSTOM: 'Select Custom',
  },
  SEND_TO_CMP: {
    SEND_TO_CMP_CLICKED: BASE_EVENT + ' - Sequence - Send to Campaign',
    SEND_TO_CMP_CONFIRM: BASE_EVENT + ' - Sequence - Send to Campaign - Save',
    SEND_TO_CMP_CANCEL: BASE_EVENT + ' - Sequence - Send to Campaign - Cancel',
  },
};
